module.exports = __webpack_public_path__ + "img/201710-3.9297cf6d.jpg";